export default "__VITE_ASSET__CA5lu9Ri__"